import React from 'react';

// Failures only: progress is the dialog's full-screen LoadingBackdrop.
const MeetingFactsheetSyncToast = ({ message, retryLabel, closeLabel, onRetry, onClose }) => (
  <div className="meeting-factsheet-sync-toast__content" aria-live="polite">
    <span className="meeting-factsheet-sync-toast__message">{message}</span>
    {onRetry && (
      <button
        type="button"
        className="meeting-factsheet-sync-toast__retry"
        onClick={event => {
          event.stopPropagation();
          onRetry();
        }}
      >
        {retryLabel}
      </button>
    )}
    {onClose && (
      <button
        type="button"
        className="meeting-factsheet-sync-toast__close"
        aria-label={closeLabel}
        onClick={event => {
          event.stopPropagation();
          onClose();
        }}
      >
        ×
      </button>
    )}
  </div>
);

export default MeetingFactsheetSyncToast;
